import { Component } from '@angular/core';
import {FrontService} from "../../../../../core/services/front/front.service";
import {AuthStateService} from "../../../../../core/services/auth/auth-state.service";
import {Service} from "../../../../../models/Service";
import {Vehicle} from "../../../../../models/Vehicle";
import {Fuel} from "../../../../../models/Fuel";
import {BookFormService} from "../../../../../core/services/book-form.service";
import {CardSelectorComponent} from "../../utils/card-selector/card-selector.component";
import {CardShadowComponent} from "../../utils/card-shadow/card-shadow.component";
import {FrontBackDirective} from "../../../../../shared/directives/buttons/front.back.directive";
import {NgForOf, NgIf} from "@angular/common";
import {updateStep} from "../../../../../store/reservationForm/stepper.actions";

@Component({
  selector: 'app-step2',
  standalone: true,
  imports: [
    CardSelectorComponent,
    CardShadowComponent,
    FrontBackDirective,
    NgForOf,
    NgIf
  ],
  templateUrl: './step2.component.html',
  styleUrl: './step2.component.css'
})
export class Step2Component {

  loading: boolean = false;

  isProfessional = false;

  serviceSelected?:Service;
  vehicleSelected?:Vehicle;
  fuelSelected?:Fuel;

  services?:Service[];
  vehicles?:Vehicle[];
  fuels?:Fuel[];

  substep: number = 1;

  // Vehículo/combustible ya conocidos al entrar en este paso (ITV caducada en
  // Baleares): se capturan una sola vez al construir el componente para no
  // volver a preguntarlos tras elegir el tipo de cita.
  private prefilledVehicle?: Vehicle;
  private prefilledFuel?: Fuel;

  constructor(private frontService:FrontService, private authStateService: AuthStateService, private bookFormService: BookFormService,) {
    const existingStep2 = this.bookFormService.currentReservationFormValue.steps.step2;
    // Solo se dan por buenos si vienen marcados explícitamente como conocidos
    // (autorrelleno Baleares): un vehicle/fuel que simplemente quedó guardado
    // de una selección manual anterior en esta misma sesión NO cuenta, para no
    // saltarnos la pregunta si el usuario retrocede y vuelve a pasar por aquí.
    if (existingStep2?.vehicleFuelKnown) {
      this.prefilledVehicle = existingStep2.vehicle;
      this.prefilledFuel = existingStep2.fuel;
    }
    // Llegamos desde "Corregir" (paso del centro): abrir directamente en el tipo
    // de vehículo del servicio ya elegido. Se consume el flag para que un
    // retroceso posterior vuelva a abrir el paso desde el principio.
    if (existingStep2?.startAtVehicle && existingStep2.service) {
      this.bookFormService.updateStep2({...existingStep2, startAtVehicle: false});
      this.serviceSelected = existingStep2.service;
      this.substep = 2;
      this.loadVehicles(existingStep2.service);
    }

    this.authStateService.currentUser.subscribe({
      next: data => {
        if (data && data.roles.includes('professional')) {
          this.isProfessional = true;
        }
      }
    })

    this.bookFormService.reservationForm$.subscribe({
      next: data => {
        if (data.steps.step2) {
          this.serviceSelected = data.steps.step2.service;
          this.vehicleSelected = data.steps.step2.vehicle;
          this.fuelSelected = data.steps.step2.fuel;
          // this.substep = data.steps.step2.subStep ?? 1;
        }
      }
    })

    this.loadServices();
  }

  public nextSubStep(step: number) {
    this.substep = step;
    // this.update();
  }

  loadServices(){
    this.loading = true;
    this.frontService.listServices().subscribe(
      {
        next: (response) => {
          if(response.data){
            this.services=response.data;
          }
          this.loading = false;
        },
        error: err => {
          this.loading = false;
        }
      }
    );
  }

  public selectService(service: Service) {
    this.serviceSelected = service;
    if (this.prefilledVehicle && this.prefilledFuel) {
      // Vehículo y combustible ya conocidos: no se preguntan de nuevo.
      this.vehicleSelected = this.prefilledVehicle;
      this.fuelSelected = this.prefilledFuel;
      this.bookFormService.setStep2({
        subStep: 3,
        service: this.serviceSelected,
        vehicle: this.prefilledVehicle,
        fuel: this.prefilledFuel,
        vehicleFuelKnown: true
      });
      return;
    }
    this.loadVehicles(service);
    this.nextSubStep(2);
  }

  loadVehicles(service: Service) {
    this.loading = true;
    this.frontService.listVehicles(service.id).subscribe(
      {
        next: (response) => {
          if(response.data){
            this.vehicles=response.data;
          }
          this.loading = false;
        },
        error: err => {
          // console.log(err);
          this.loading = false;
        }
      }
    );
  }

  public selectVehicle(vehicle:Vehicle) {
    this.vehicleSelected = vehicle;
    if(this.serviceSelected){
      this.loadFuels(vehicle, this.serviceSelected);
      if (this.vehicleSelected.need_fuel) {
        this.nextSubStep(3);
      }
    }
  }

  loadFuels(vehicle:Vehicle, service: Service){
    this.loading = true;
    this.frontService.listFuels(service.id,vehicle.id).subscribe(
      {
        next: (response) => {
          if(response.data){
            this.fuels=response.data;
            if (this.vehicleSelected && !this.vehicleSelected.need_fuel) {
              let fuel =  this.fuels ? this.fuels.find(fuel => fuel.slug === "sin-combustible") : null;
              if (fuel) {
                this.bookFormService.setStep2({
                  subStep: this.substep,
                  service: this.serviceSelected,
                  vehicle: this.vehicleSelected,
                  fuel: fuel
                })
              }
            }
          }
          this.loading = false;
        },
        error: err => {
          this.loading = false;
        }
      }
    );
  }

  public selectFuel(fuel: Fuel) {
    this.fuelSelected = fuel;

    this.bookFormService.setStep2({
      subStep: this.substep,
      service: this.serviceSelected,
      vehicle: this.vehicleSelected,
      fuel: this.fuelSelected
    })
    // this.update();
  }

  public backSubStep(){
    if (this.substep > 1) {
      this.substep--;
    } else {
     this.bookFormService.setCurrentStep(1);
    }
  }

}
